import "slick-carousel/slick/slick";

jQuery(document).ready(function () {

    var productSliderLength = jQuery(".product-slider").attr("data-items")
    jQuery(".product-slider").on(
        "init",
        function (event, slick, currentSlide) {
            jQuery('.slick-current').prevAll().addClass('prev');
            jQuery('.slick-current').nextAll().addClass('next');

            setTimeout(function () {
                jQuery('.slick-current').prevAll().addClass('prev-show');
                jQuery('.slick-current').nextAll().addClass('next-show');
            }, 100);
        }
    );


    var productSliderSettings
    var productDescriptionSliderSettings

    // -----------------------------------------------------------------------------------------------------------------
    // Slider variations
    // -----------------------------------------------------------------------------------------------------------------
    if (productSliderLength == 2) {
        // 2 element slider
        productDescriptionSliderSettings = {
            initialSlide: 0,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        initialSlide:0,
                        infinite: true,
                    },
                },
            ],
        }
        productSliderSettings = {
            initialSlide: 0,
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            centerPadding: "20%",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        initialSlide: 0,
                        centerPadding: "40%",
                        slidesToShow: 1,
                        centerMode: true,
                        infinite: false
                    },
                }
            ],
        }

    } else if (productSliderLength == 3) {
        // 3 element slider
        productDescriptionSliderSettings = {
            initialSlide: 0,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        initialSlide: 1,
                        infinite: true,
                    },
                },
            ],
        }
        productSliderSettings = {
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            initialSlide: 0,
            centerPadding: "20%",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        initialSlide: 1,
                        slidesToShow: 1,
                        centerPadding: "33.33%",
                        infinite: true,
                    },
                }
            ],
        }

    } else if (productSliderLength == 4) {
        // 4 element slider
        productDescriptionSliderSettings = {
            initialSlide: 0,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        initialSlide: 0,
                        infinite: true,
                    },
                },
                {
                    breakpoint: 1400,
                    settings: {
                        initialSlide: 1,
                        infinite: false,
                    },
                }
            ],
        }
        productSliderSettings = {
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            initialSlide: 0,
            centerPadding: "20%",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: 0,
                        slidesToShow: 3,
                        infinite: true,
                        initialSlide: 0,
                    },
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: "20%",
                        initialSlide: 1,
                        infinite: false,
                    },
                }
            ],
        }
    } else if (productSliderLength == 5) {
        // 5 element slider
        productDescriptionSliderSettings = {
            initialSlide: 0,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        initialSlide: 0,
                        infinite: true,
                    },
                },
                {
                    breakpoint: 1400,
                    settings: {
                        initialSlide: 0,
                        infinite: false,
                    },
                }
            ],
        }
        productSliderSettings = {
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            initialSlide: 0,
            centerPadding: "20%",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: 0,
                        slidesToShow: 3,
                        infinite: true,
                        initialSlide: 0,
                    },
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: "20%",
                        initialSlide: 0,
                        infinite: true,
                    },
                }
            ],
        }
    } else {
        // more then 5 element slider
        productDescriptionSliderSettings = {
            initialSlide: 0,
            infinite: true,
        }
        productSliderSettings = {
            centerPadding: 0,
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5,
                    },
                }
            ],
        }

    }
    // -----------------------------------------------------------------------------------------------------------------
    // Common Product slider settings
    productSliderSettings.asNavFor = jQuery(".product-description-slider")
    productSliderSettings.mobileFirst = true
    productSliderSettings.arrows = false
    productSliderSettings.focusOnSelect = true
    // -----------------------------------------------------------------------------------------------------------------
    // Common Product description slider settings
    productDescriptionSliderSettings.asNavFor = jQuery(".product-slider")
    productDescriptionSliderSettings.mobileFirst = true
    productDescriptionSliderSettings.arrows = false
    productDescriptionSliderSettings.dots = true
    productDescriptionSliderSettings.fade = true
    // -----------------------------------------------------------------------------------------------------------------
    // Init slick if more than 1 element
    if (productSliderLength > 1) {
        jQuery(".product-slider").slick(productSliderSettings)
        jQuery(".product-description-slider").slick(productDescriptionSliderSettings);
    }
    // -----------------------------------------------------------------------------------------------------------------


    jQuery(".product-slider").on(
        "beforeChange",
        function (event, slick, currentSlide) {
            jQuery('.slick-slide').removeClass('prev next prev-show next-show');
        }
    );

    jQuery(".product-slider").on(
        "afterChange",
        function (event, slick, currentSlide) {
            jQuery('.slick-current').prevAll().addClass('prev');
            jQuery('.slick-current').nextAll().addClass('next');

            setTimeout(function () {
                jQuery('.slick-current').prevAll().addClass('prev-show');
                jQuery('.slick-current').nextAll().addClass('next-show');
            }, 100);
        }
    );

    jQuery(".packshot-wrap").on("mouseenter", function () {
        // console.log(jQuery(this).find(".category-label").addClass("active"));
    });

    jQuery(".packshot-wrap").on("mouseleave", function () {
        // console.log(jQuery(this).find(".category-label").removeClass("active"));
    });
});
